import styled from 'styled-components'

const LinearSliderGalleryStyle = styled.div`
	--titleMarginBottom: var(--sp7x);
	--titleMaxWith: var(--sp200x);
	--sectionPaddingTop: var(--sp21x);
	--sectionPaddingBottom: var(--sp109x);
	--sliderMarginTop: calc(calc(var(--sectionPaddingBottom) - var(--sectionPaddingTop)) * -1);

	.swiper {
		margin-top: var(--sliderMarginTop);
	}

	.content-wrap {
		padding-top: var(--sectionPaddingTop);
		padding-bottom: var(--sectionPaddingBottom);

		.section {
			margin-bottom: unset;
		}

		.title {
			margin-bottom: var(--titleMarginBottom);
            max-width: var(--titleMaxWith);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXLMin}) {
		--titleMarginBottom: var(--sp5x);
		--sectionPaddingTop: var(--sp15x);
		--sectionPaddingBottom: var(--sp80x);
		--titleMaxWith: var(--sp150x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeLMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionPaddingTop: var(--sp12x);
		--sectionPaddingBottom: var(--sp63x);
		--titleMaxWith: var(--sp117x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeMMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionPaddingTop: var(--sp12x);
		--sectionPaddingBottom: var(--sp67x);
		--titleMaxWith: var(--sp112x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeSMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionPaddingTop: var(--sp10x);
		--sectionPaddingBottom: var(--sp54x);
		--titleMaxWith: var(--sp101x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXSMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionPaddingTop: var(--sp8x);
		--sectionPaddingBottom: var(--sp54x);
		--titleMaxWith: var(--sp98x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.TabletSizeMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionPaddingTop: var(--sp8x);
		--sectionPaddingBottom: var(--sp54x);
		--titleMaxWith: 100%;
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--titleMarginBottom: var(--sp3x);
		--sectionPaddingTop: var(--sp6x);
		--sectionPaddingBottom: var(--sp44x);
		--titleMaxWith: 100%;
	}
`

export default LinearSliderGalleryStyle
